import type { JokerInterpretation } from "@joker-holdem/core";
import { badgeCategoryKey, badgeCategoryLabelJa } from "./cardUtils.js";

interface CategoryBadgeProps {
  details: JokerInterpretation;
}

/**
 * Showdown result badge (2026-07-17 フィードバック #1): sits to the right of
 * each player's joker-interpretation card, naming the hand category that
 * interpretation produced. Color keyed by category via a `badge-<key>`
 * class (see styles.css); royal flush is split out of straight-flush so it
 * can get its own rainbow+gold-border treatment.
 */
export function CategoryBadge({ details }: CategoryBadgeProps) {
  const key = badgeCategoryKey(details.category, details.bestFive);
  return <span className={`category-badge badge-${key}`}>{badgeCategoryLabelJa(key)}</span>;
}
